/**
 * FrequencySelector Component
 * 
 * Radio buttons for selecting interest frequency
 * Options: Monthly, Quarterly, Annually
 * Integrated with i18next for multilingual labels
 */
import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';
import { Label } from './ui/label';

const FREQUENCY_OPTIONS = [
  {
    value: 'MONTHLY',
    labelKey: 'interest.frequency_monthly'
  },
  {
    value: 'QUARTERLY',
    labelKey: 'interest.frequency_quarterly'
  },
  {
    value: 'ANNUALLY',
    labelKey: 'interest.frequency_annually'
  }
];

const FrequencySelector = ({ value, onChange, disabled = false, className = '' }) => {
  const { t } = useLanguage();

  return (
    <div className={`space-y-2 ${className}`}>
      <Label>{t('interest.frequency')}</Label>
      <RadioGroup
        value={value}
        onValueChange={onChange}
        disabled={disabled}
        className="flex flex-col space-y-2"
      >
        {FREQUENCY_OPTIONS.map((option) => (
          <div key={option.value} className="flex items-center space-x-2">
            <RadioGroupItem
              value={option.value}
              id={`frequency-${option.value}`}
              disabled={disabled}
            />
            <Label
              htmlFor={`frequency-${option.value}`}
              className="cursor-pointer font-normal"
            >
              {t(option.labelKey)}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};

export default FrequencySelector;
